function getHTMLDate(date) {
  if( date === null ) return null

  if( String(date) === 'Invalid Date' ) return ''

  const [mm, dd, yyyy] = date.toLocaleDateString('en-us').split('/')

  const month = mm.length === 1 ? '0'+mm : mm
  const day = dd.length === 1 ? '0'+dd : dd

  return `${yyyy}-${month}-${day}`
}

function getTimestampFromHTMLDate (date) {
  const [yyyy, mm, dd] = date.split('-')

  return new Date(`${yyyy}/${mm}/${dd}`).getTime()
}
